import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import Loader from 'Components/Atoms/Loader/Loader';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createRelation, fetchAllDatasets, saveRelation } from 'Store/FieldManagement/Actions';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { getAllDatasets, getAllRelations, getDatasetLabels } from 'Store/FieldManagement/Selectors';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';
import styles from './Relations.module.sass';

const Relations = ({datasets, datasetLabels, relations, ...props}: any) => {
    const token: any = localStorage.getItem(window.btoa('accessToken'));
    const accessToken = window.atob(token);

    const [isEdit, setEdit] = useState(false);

    const [isLoading, setLoading] = useState(true);
    const [relationIds, setRelations] = useState([]);
    const [selectedRelation, setSelectedRelation] = useState([]);

    const fetchRelations = () => {
        fetch(`${API_URL}/api/field-management/relations`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        }).then(async (item: any) => {
            const response = await item.json();
            setRelations(response?.data);
            setLoading(false);
        });
    }

    useEffect(() => {
        props.fetchAllDatasets();
        fetchRelations();

        return () => {};
    }, []);

    const [isFetching, setFetching] = useState(false);
    const [relationValues, setRelationValues] = useState([]);
    const [editedRelationValues, setEditRelationValues] = useState([]);

    useEffect(() => {
        if (!selectedRelation[0]) return;
        setFetching(true);
        setEdit(false);
        
        fetch(`${API_URL}/api/field-management/relations/${selectedRelation[0]}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        }).then(async (item: any) => {
            const response = await item.json();
            setRelationValues(response?.data);
            setEditRelationValues(response?.data);
            setFetching(false);
        });

        return () => {};
    }, [selectedRelation]);

    const handleCancel = () => setEditRelationValues(relationValues);

    const handleSave = () => {
        setLoading(true);
        
        props.saveRelation({dataset_key: selectedRelation[0], relations: editedRelationValues}).then(() => {
            setLoading(false);
            setRelationValues(editedRelationValues);
        });
    }

    useEffect(() => {
        setEdit(!!selectedRelation[0]);
    }, [selectedRelation]);

    return isLoading
    ? <Loader description="Relaties ophalen..."/>
    : <div className={styles['relations']}>
        
        <div className={styles['relations__wrapper']}>
            <div className={styles['relations__dataset']}>
                <Field
                    isEdit={true}
                    onChange={(value) => setSelectedRelation(value)}
                    value={selectedRelation}
                    type={FieldType.Dropdown}
                    fieldProperties={{
                        datasets: {
                            dataset: props.datasets
                        },
                        debounceDelay: 500
                    }}
                />
            </div>
            { isFetching && <Loader description="Relaties ophalen..." /> }
            {
                    !isFetching && selectedRelation?.length > 0 && <>
                        <div className={styles['relations__divider']}></div>
                        <div className={styles['relations__dataset']}>
                            <Field
                                isEdit={isEdit}
                                onChange={(value) => setEditRelationValues(value)}
                                value={editedRelationValues || []}
                                type={FieldType.Multi_Selector}
                                alignLeft
                                fieldProperties={{
                                    isInline: false,
                                    datasets: {
                                        dataset: props.datasets
                                    }
                                }}
                            />
                        </div>
                        {
                            relationValues.length != editedRelationValues.length &&
                            <div style={{marginLeft: '8px'}}>
                                <EditButtons
                                    defaultEdit
                                    onEdit={() => {}}
                                    onSave={handleSave}
                                    onCancel={handleCancel}
                                    isEdit={isEdit}
                                />
                            </div>
                        }
                    </>
                }
            </div>
        </div>
    ;
}

export default connect(
    (state: any) => ({
        datasets: getAllDatasets(state),
        datasetLabels: getDatasetLabels(state),
        relations: getAllRelations(state)
    }), {
        fetchAllDatasets,
        createRelation,
        saveRelation
    }
)(Relations);